import axios, { AxiosResponse } from 'axios'
import { IChatMessage } from '@common/interfaces/chat-message.interface'
import { FabTypes } from '@/components/analytics/customerCustom/fab.types'

type HistoryResponse = AxiosResponse<IChatMessage[]>

export class ConversationLogService {
  private readonly url: string

  constructor(botName: string) {
    this.url = `${process.env.VUE_APP_BACKEND_URL}/bots/${botName}/conversation`
  }

  async getChatHistory(): Promise<IChatMessage[]> {
    const result: HistoryResponse = await axios.get(`${this.url}/log`)
    return result.data.map(this.parseMessage)
  }

  async getMonthlyChatRatings(month: number, year: number): Promise<FabTypes[]> {
    const result: AxiosResponse<FabTypes[]> = await axios.get(`${this.url}/ratings/${month}/${year}`)
    return result.data
  }

  async getChatHistoryRecent(): Promise<IChatMessage[]> {
    const result: HistoryResponse = await axios.get(`${this.url}/log/latest`)
    return result.data.map(this.parseMessage)
  }

  /**
   * Convert timestamp from string to date
   */
  private parseMessage(message: IChatMessage): IChatMessage {
    message.timestamp = new Date(message.timestamp)
    return message
  }
}
